// extracted by mini-css-extract-plugin
export default {"carouselContainer":"styles_carouselContainer__HJvRM","viewport":"styles_viewport__Eq48f","itemsContainer":"styles_itemsContainer__NxZ0Y","item":"styles_item__cOPBy"};